import apiConfig from '../../config/apiConfig';
import { apiBaseURL, toastifyType, viewsActionType } from '../../constants';
import { setLoading } from './loadingAction';
import { fetchCustomColumnsViews } from './CustomColumnsViewsAction';
import { addTost } from './toastAction';
import { metaDataAction } from './metaDataAction';


export const fetchColumnsViews = (sectionName, currentPageTwo, perPageTwo, setTotalRecordsTwo, setTotalPageTow) => async (dispatch) => {
    try {
        const response = await apiConfig.get(apiBaseURL.VIEWS + '/' + sectionName + '?page=' + currentPageTwo + '&perPage=' + perPageTwo)
        dispatch({ type: viewsActionType.FETCH_VIEWS, payload: response.data?.data });
        setTotalRecordsTwo && setTotalRecordsTwo(response.data?.data?.totalRecords)
        setTotalPageTow && setTotalPageTow(response.data?.data?.totalPage)
    } catch (error) {
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const fetchColumnsView = (sectionName, setLoading, setTotalRecords, setTotalPage) => async (dispatch) => {
    // dispatch(setLoading(true))
    // setLoading && setLoading(true)
    try {
        const response = await apiConfig.get(apiBaseURL.VIEWS + '/' + sectionName + '/details')
        dispatch({ type: viewsActionType.FETCH_VIEW, payload: response.data?.data });
        setLoading && setLoading(false)
        const getColumns = response.data?.data.columns;
        const getToleranceFields = response.data?.data.toleranceFields;
        const getObjId = [...getColumns, ...getToleranceFields].length ? [...getColumns, ...getToleranceFields]?.map((item) => item?.toleranceParameterFields?._id) : []
        const portfolioId = localStorage.getItem('portfolioId');
        dispatch(fetchCustomColumnsViews(response.data?.data?.section, '', setTotalRecords, setTotalPage, getObjId, portfolioId))
    } catch (error) {
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
        setLoading && setLoading(false)
    }
}


export const addColumnsViews = (sectionName, data, type, currentPageTwo, perPageTwo, setTotalRecordsTwo, setTotalPageTow) => async (dispatch) => {
    try {
        const response = await apiConfig.post(apiBaseURL.VIEWS, data)
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        type === 'add' && dispatch(fetchColumnsViews(sectionName, currentPageTwo, perPageTwo, setTotalRecordsTwo, setTotalPageTow))
    } catch (error) {

        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const deleteColumnsViews = (sectionName, data, currentPageTwo, perPageTwo, setTotalRecordsTwo, setTotalPageTow) => async (dispatch) => {
    try {
        const response = await apiConfig.post(apiBaseURL.VIEWS + '/config', data)
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        dispatch(fetchColumnsViews(sectionName, currentPageTwo, perPageTwo, setTotalRecordsTwo, setTotalPageTow))
    } catch (error) {
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const activeColumnsViews = (sectionName, data, currentPageTwo, perPageTwo, setTotalRecordsTwo, setTotalPageTow) => async (dispatch) => {
    try {
        const response = await apiConfig.post(apiBaseURL.VIEWS + '/config', data)
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        dispatch(fetchColumnsViews(sectionName, currentPageTwo, perPageTwo, setTotalRecordsTwo, setTotalPageTow))
    } catch (error) {
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}



export const newFetchColumnsViews = (sectionName, filter) => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        const filterData = `?page=${filter?.page ? filter?.page : ''}&perPage=${filter?.perPage ? filter?.perPage : ''}`
        const response = await apiConfig.get(apiBaseURL.VIEWS + '/' + sectionName + filterData)
        dispatch({ type: viewsActionType.FETCH_VIEWS_NEW, payload: response.data?.data });
        filter && dispatch(metaDataAction({ pageNumber: response.data?.data?.currentPage, pageSize: filter?.perPage, totalItems: response?.data?.data?.totalRecords }))
        dispatch(setLoading(false))
    } catch (error) {
        dispatch(setLoading(false))
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const newAddColumnsViews = (sectionName, data, setLoading, onHide) => async (dispatch) => {
    try {
        setLoading(true);
        const response = await apiConfig.post(apiBaseURL.VIEWS, data)
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        if (response?.data?.success) {
            onHide()
        }
        dispatch(newFetchColumnsViews(sectionName, { page: 1, perPage: 10 }))
        dispatch(setLoading(false))
    } catch (error) {
        setLoading(false);
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const newDeleteColumnsViews = (data, sectionName) => async (dispatch) => {
    try {
        const response = await apiConfig.post(apiBaseURL.VIEWS + '/config', data)
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        dispatch(newFetchColumnsViews(sectionName, { page: 1, perPage: 10 }))
    } catch (error) {
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const newActiveColumnsViews = (data, sectionName) => async (dispatch) => {
    try {
        const response = await apiConfig.post(apiBaseURL.VIEWS + '/config', data)
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        dispatch(newFetchColumnsViews(sectionName, { page: 1, perPage: 10 }))
        return response.data
    } catch (error) {
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const fetchColumnsViewFiels = (id, setLoading) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await apiConfig.get(apiBaseURL.VIEWS + '/' + id + '/details')
        // dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        setLoading(false)
        return response.data
    } catch (error) {
        setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const newAddColumnsFields = (data) => async (dispatch) => {
    try {
        setLoading(true);
        const response = await apiConfig.post(apiBaseURL.VIEWS, data)
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        // dispatch(newFetchColumnsViews(sectionName, { page: 1, perPage: 10 }))
        dispatch(setLoading(false))
        return response.data
    } catch (error) {
        setLoading(false);
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const getViewName = (id, setLoading) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await apiConfig.get(apiBaseURL.VIEWS + '/' + id + '/name')
        // dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        setLoading(false)
        return response.data
    } catch (error) {
        setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

export const updateViewName = (id, name, setLoading, onHide, sectionName) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await apiConfig.put(apiBaseURL.VIEWS + '/' + id, { name })
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        if (response?.data?.success) {
            onHide()
        }
        dispatch(newFetchColumnsViews(sectionName, { page: 1, perPage: 10 }))
        setLoading(false)
        return response.data
    } catch (error) {        
        setLoading(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}

